Vue.component('ack-shop-filters', {
	delimiters: ['${', '}$'], // (i) We set up custom delimiters to avoid conflict with liquid interpolations.
	template: '#ack-shop-filters',

	created() {
		EventBus.$on('activeCollectionFilter', () => {
			this.emptyAccordionList();
			EventBus.$emit('activeMainProduct');
			EventBus.$emit('activeInnerProduct');
			EventBus.$emit('showListedAccordions');
		});
		EventBus.$on('showListedAccordions', () => {
			this.toBeActiveAccordionList.forEach((openedAccordion) => {
				let collapseToBeCloseEle = document.querySelector(
					`#${openedAccordion.replace('heading', 'collapse')}`,
				);
				const collapseToBeClose = bootstrap.Collapse.getOrCreateInstance(collapseToBeCloseEle);

				collapseToBeClose.show();
			});
		});
	},
	props: {
		filters: {
			type: Object,
			required: true,
		},
		isMobile: {
			type: Boolean,
		},
	},
	computed: {
		//...Vuex.mapGetters('navBar', ['switchMobileDropdowns']),
		...Vuex.mapGetters('shop', ['productList', 'collectionProductList', 'toBeActiveAccordionList']),
		...Vuex.mapGetters('localization', [
			'countryCode',
			'isLatam',
			'isUsCaAuNzPrIn',
			'isEurope',
			'isRestOfWorld',
			'isUS_CA',
		]),
	},
	data() {
		return {
			checkedItems: [],
			solChecked: false,
			dentiqChecked: false,
			freeshapeChecked: false,
			curiePlusChecked: false,
			solItems: [
				'SOL Large BP',
				'SOL Medium BP',
				'SOL Small BP',
				'SOL Vat Assembly With Vat Box',
				'SOL Vat Box',
				'Print Screen Pack with 2 for SOL',
			],
			dentiqItems: [
				'DENTIQ Vat',
				'Print Screen Pack With 3 For FreeShape & DENTIQ',
				'DENTIQ Build Platform',
			],
			freeshapeItems: ['FreeShape Vat', 'FreeShape Build Platform'],
			curiePlusItems: ['Nfinity', 'N2 Cover'],
		};
	},
	methods: {
		//...Vuex.mapActions(['sayHi', 'someAction']),
		//...Vuex.mapActions('navBar', ['sayHi', 'closeAllMobileDropdowns'])
		...Vuex.mapActions('shop', ['emptyAccordionList']),
		loadBundle(bundleTag) {
			this.$emit('load-bundle', bundleTag);
		},
	},
	beforeDestroy() {},
	watch: {
		isMobile: {
			handler() {},
			deep: false,
		},
		// solChecked(newValue) {
		//   if (newValue) {
		//     this.checkedItems = [...this.checkedItems, ...this.solItems]
		//   } else {
		//     this.checkedItems = this.checkedItems.filter(item => !this.solItems.includes(item))
		//   }
		// }
	},
});
